import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { Navigator } from 'src/app/components/menu/navigator';
import { ConfigService } from 'src/app/services/config/config.service';

@Component({
  selector: 'app-popover-track-consent',
  templateUrl: './popover-track-consent.component.html',
  styleUrls: ['./popover-track-consent.component.scss'],
})
export class PopoverTrackConsentComponent implements OnInit {
  @Input() data: any;
  public backgroundClass = "blue-background";
  public addStars: boolean = true;
  public enableAnimation: boolean = false;
  private timeout;

  constructor(public popoverController: PopoverController, private navigator: Navigator,
    private config: ConfigService) { }

  ngOnInit() {
    const closeTimer = this.config.getConfig().TRACK_CONSENT_POPOVER_AUTO_CLOSE_TIMER || 15000;
    this.timeout = setTimeout(() => {
      this.onClickOk();
    }, closeTimer);
  }

  onClickOk() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.popoverController.dismiss();
    this.navigator.dismissPriorityPopover();
    if (this.data.onCloseFunc) {
      let func = this.data.onCloseFunc;
      func();
    }
  }

}
